/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crisp_Funny_Iguana_BelieveInputs */

const fr_crisp_funny_iguana_believe = /** @type {(inputs: Crisp_Funny_Iguana_BelieveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programme`)
};

/**

* @param {Crisp_Funny_Iguana_BelieveInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const crisp_funny_iguana_believe = /** @type {((inputs?: Crisp_Funny_Iguana_BelieveInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crisp_Funny_Iguana_BelieveInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_crisp_funny_iguana_believe(inputs)
});